(function (module) {
    'use strict';

    function MyProfileCtrl($state, Store) {
        this.$onInit = () => {

            this.current = Store.getCurrentUser();

            this.orderBy = 'createdAt';
        };

    }

    module
        .config(function ($stateProvider, $translatePartialLoaderProvider) {
            $stateProvider
                .state('root.my-profile', {
                    url: '/my-profile',
                    data: {
                        pageTitle: 'MY_PROFILE.PAGE_TITLE'
                    },
                    views: {
                        'content@root': {
                            template: '<my-profile-component/>'
                        }
                    },
                    bodyClass: 'page--myProfile'
                });

            $translatePartialLoaderProvider.addPart('/js/my-profile');

        })
        .component('myProfileComponent', {
            templateUrl: '/js/my-profile/my-profile.html',
            controller: MyProfileCtrl
        });

})(angular.module('rocket.components'));
